import { GroupView } from '@views/GroupView';
import actionResponse, { ActionResponse } from '../../ActionResponse';
import apiResponse from '@stores/ApiResponse';
import { GroupStore } from '@stores/GroupStore';

export class CreateGroupAction {
  constructor(private readonly store: GroupStore = new GroupStore()) {}

  async Execute(reason: 'SAVE' | string, selectedGroup: GroupView): Promise<ActionResponse> {
    if (reason && reason === 'SAVE') {
      const response = await apiResponse.handleApiResponse(() => this.store.Write(selectedGroup));
      return actionResponse.Success('CreateGroupAction.execute done', response);
    }
    return actionResponse.Success('CreateGroupAction.execute done');
  }
}
